<script>
import MonitoringReport from '@/views/pages/monitoring-report/MonitoringReport.vue'

export default {
  name: 'MonitoringReportOtm',
  components: { MonitoringReport },
}
</script>

<template>
  <monitoring-report type="monitoringReportOtmItmList" />
</template>

<style scoped>

</style>
